import { styled } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Grid from "@mui/material/Grid"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router"
import "./ConsultantProfile.scss"
import { useHistory } from "react-router"
import { getAvailability, getConsultantProfile } from "../../../core/services/api"
import { useSelector } from "react-redux"

const Item = styled(Paper)(({ theme }) => ({
  textAlign: "left",
  paddingLeft: "10px",
  paddingRight: "10px",
}))

export default function ConsultantProfile() {
  const { consultantId }: any = useParams()
  const [consultantProfile, setconsultantProfile] = useState<any>([])
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const [cwa, setCwa] = useState<any>()
  const [avail, setavail] = useState<any>()
  const [data, setData] = useState<any>([])
  const [refData, setrefData] = useState([])

  const element = document.getElementById("ConsultantProfileContainer")
  useEffect(() => {
    if (element) {
      element?.scrollIntoView({ behavior: "smooth" })
    }
  }, [element])

  useEffect(() => {
    getConsultantProfile(consultantId)
      .then((res: any) => {
        setconsultantProfile(res)
      })
      .catch((err: any) => {
        console.log("err", err)
      })
    if (consultantId) {
      getAvailability(`?centerId=${userDetail?.currentCenter?.centerId}`).then(
        (res) =>
          // console.log(res, "check")
          console.log(res, "checked")
      )
    }


  }, [])


  useEffect(() => {
    console.log(data, avail)
    if (avail?.length > 0 && data?.length > 0) {
      let arr: any[] = []
      data?.map((eachConsultant: any) => {
        const avlOfCons = avail.find(
          (eachObj: any) => eachConsultant?.id === eachObj?.consultantId
        )
        let temp = Object.assign({}, eachConsultant)
        console.log("avlOfCons", avlOfCons?.availabilityTimeFrame)
        if (avlOfCons?.availabilityTimeFrame && Object.keys(avlOfCons?.availabilityTimeFrame)?.length > 0)
          temp["availabilityTimeFrame"] = getAvail(
            avlOfCons?.availabilityTimeFrame
          )
        // temp["availabilityTimeFrame"] = avlOfCons?.availabilityTimeFrame
        arr.push(temp)
      })
      setCwa(arr)
    }
  }, [data, avail])
  console.log(cwa, "ceaaa")

  const getAvail = (availTF: any) => {
    let obj: any = []
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ]
    const today = new Date()
    const dayOfWeek = daysOfWeek[today.getDay()]
    Object.keys(availTF).map((each: any) => {
      if (each.startsWith(dayOfWeek.toUpperCase())) {
        // if(each.split(""))
        obj.push(availTF[each])

      }

    })

    console.log(obj.sort(), "objjj")
    return obj.sort()
  }
  console.log(consultantProfile, "consultantProfile")

  const history = useHistory()

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "20px",
        marginBottom: "40px"
      }}
    >
      <div className="doctor-title" id="ConsultantProfileContainer">
        <div
          className="back-image"
          onClick={() => {
            history.push("/consultant")
          }}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>
        {consultantProfile.name}
      </div>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Item
            sx={{
              height: "335px",
              borderStyle: "solid",
              boxShadow: "0px 3px 6px #3F7AF54A",
              border: "1px solid #5874FF",
              borderRadius: "27px",
              // backgroundColor: "#614DFF",
            }}
          >
            <img
              className="doctor-image"
              src={consultantProfile.consultantProfilePic || "/assets/images/doctor.svg"}
              onError={(e) => {
                e.currentTarget.onerror = null; // Prevents infinite loop if default image is also missing
                e.currentTarget.src = "/assets/images/doctor.svg"; // Fallback to default image if loading fails
              }}
              alt="Consultant Profile"
            />

          </Item>
        </Grid>
        <Grid item xs={9}>
          <Item
            sx={{
              height: "335px",
              position: "relative",
              boxShadow: "0px 3px 6px #3F7AF54A",
              border: "1px solid #5874FF",
              overflow: "scroll",
              borderRadius: "27px",
              padding: "20px 30px"
            }}
          >





            <div className="doctor-primary">
              <div className="doctor-subtitle">Dr. {consultantProfile.name}</div>
              <p className="doctor-education">

              </p>
              <div className="doctor-speciality">
                Educational Qualification - {consultantProfile.educationalQualification?.join("\r\n")}
                Service Offered - {consultantProfile.servicesOffered}{" "}<br />Specialty - {consultantProfile.specialization}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="doctor-phone">
                <img
                  className="iconButton"
                  alt="Logout"
                  src="../../assets/images/call.svg"
                  style={{ width: "20px", height: "30px", marginRight: "5px", color: "#024cf2" }}
                />
                {consultantProfile.phoneNumber}
              </div>
              <div className="doctor-email">{consultantProfile.emailId}</div>
            </div>

          </Item>
        </Grid>

        {/* <Grid item xs={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Item
                sx={{
                  height: "159px",
                  boxShadow: "0px 3px 6px #3495FB66",
                  border: "1px solid #2D81D9",
                  borderRadius: "27px",
                  backgroundColor: "#3495FB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {console.log(consultantProfile, "consultantProfile")}
                <div className="doctor-exp-pat">
                  <p className="experience">Educational Qualification</p>
                  <p className="experience-number">{consultantProfile?.educationalQualification}</p>
                </div>



              </Item>

            </Grid>
            
          </Grid>
        </Grid> */}

        <Grid item xs={12}>
          <Item
            sx={{
              height: "fitContent",
              minHeight: "300px",
              borderStyle: "solid",
              boxShadow: "0px 3px 6px #3F7AF54A",
              border: "1px solid #5874FF",
              borderRadius: "27px",
            }}
          >
            <div className="doctor-summary">{consultantProfile.summary}</div>
          </Item>
        </Grid>
      </Grid>
    </Box >
  )
}
